// extracted by mini-css-extract-plugin
module.exports = {"container":"ez","productName":"fz","modal":"gz","dimensions":"hz","recipientEmail":"iz","lowStock":"jz"};